import React, { useState } from "react"; // Added useState import
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import config from '../functions/config';


const AboutUs = () => {

      const [isOpen, setIsOpen] = useState(false);

const toggleNavbar = () => {
  setIsOpen(!isOpen);
};
return (
  <div className="about-us-page">
  {/* Navbar */}
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark py-3 fixed-top">
    <div className="container-fluid">
      <a className="navbar-brand" href="#">📚 Library</a>
      <button 
        className="navbar-toggler" 
        type="button" 
        onClick={toggleNavbar}
        aria-expanded={isOpen}
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}>
        <ul className="navbar-nav ms-auto">
          <li className="nav-item">
            <Link className="nav-link" to="/">Home</Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/about">About</Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/login">Login</Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/signup">Register</Link>
          </li>
        </ul>
      </div>
    </div>
  </nav>

      {/* About Us Content */}
      <div className="container mt-5 pt-5 mb-5">
        <h1 className="text-center mb-4">About Us</h1>
        <div className="row justify-content-center mt-5">
          <div className="col-md-10">
            <p className="lead text-justify">
              Welcome to the Library Management System! Our mission is to provide a user-friendly platform for managing library resources efficiently. Whether you're a student, a teacher, or a library staff member, our system is designed to simplify the process of borrowing and returning books, managing member accounts, and keeping track of available resources.
            </p>
            <p className="lead text-justify">
              Our library system offers a wide range of features to enhance your library experience, including:
            </p>
            <ul className="list-group mb-4">
              <li className="list-group-item">📚 Easy access to book catalogs</li>
              <li className="list-group-item">🔍 Advanced search and filtering options</li>
              <li className="list-group-item">🧾 Automated borrowing and returning process</li>
              <li className="list-group-item">📈 Real-time tracking of borrowed books</li>
              <li className="list-group-item">👥 Member management system</li>
            </ul>
            <p className="lead text-justify">
              Our dedicated team is constantly working to improve the system and add new features to meet the needs of our users. We believe that libraries are essential to education and knowledge sharing, and our goal is to make them more accessible to everyone.
            </p>
            <p className="lead text-justify">
              Thank you for choosing our Library Management System. We look forward to serving your library needs!
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-dark text-light text-center py-3 mt-5 fixed-bottom">
        <p className="mb-0">&copy; {new Date().getFullYear()} Library Management System | Designed with ❤️ by Your Team</p>
      </footer>
    </div>
  );
};

export default AboutUs;
